import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 一键找人
  getTrackRecords(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_TRACK_RECORD, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAlertInterval(postData) {
    return http.post(URL.API_SECURITY_GET_NOTICE_INTERVAL, postData)
  },
  /**
   * 保存通知间隔
   * @param Object postData
   */
  saveAlertInterval(postData) {
    return http.post(URL.API_SECURITY_NOTICE_INTERVAL, postData)
  },
  /**
   * 查告警列表
   * @param Object postData
   */
  getAlertList(postData) {
    return http.post(URL.API_SECURITY_ALERT_LIST, postData)
  },
  /**
   * 查天告警类型统计-维度=告警类型
   * @param Object postData
   */
  getAlertStatisticsByAlertType(postData) {
    return http.post(URL.API_SECURITY_ALERT_TYPE, postData)
  },
  /**
   * 查天告警类型统计-维度=人员
   * @param Object postData
   */
  getAlertStatisticsByMember(postData) {
    return http.post(URL.API_SECURITY_ALERT_MEMBER_INFO_BYDAY, postData)
  },
  /**
   * 查某人时间范围内告警统计-维度:告警类型
   * @param Object postData
   */
  getMemberAlertStatistics(postData) {
    return http.post(URL.API_SECURITY_ALERT_MEMBER_INFO, postData)
  },
  updateNoticeGroupEnable(postData) {
    return http.post(URL.API_SECURITY_UPDATE_NOTICE_ENABLE, postData)
  },
  getNoticeDevices(postData) {
    return http.post(URL.API_SECURITY_NOTICE_DEVICE_LIST, postData)
  },
  getAlertInfo(postData) {
    return http.get(URL.API_SECURITY_NOTICE_AlERT_INFO, postData)
  },
  getAlertDetail(postData) {
    return http.post(URL.API_SECURITY_NOTICE_AlERT_DETAIL, postData)
  },
  //

  // 报警处理数量统计
  getAlertProcessCountStatistics(postData) {
    return http.get(
      URL.API_SCHOOL_SECURITY_ALERT_PROCESS_COUNT_STATISTICS,
      postData
    )
  },
  // 报警类型数量统计
  getAlertTypeCountStatistics(postData) {
    return http.get(
      URL.API_SCHOOL_SECURITY_ALERT_TYPE_COUNT_STATISTICS,
      postData
    )
  },
  // 报警类型数量统计-我的班级
  getMyclassAlertTypeCountStatistics(postData) {
    return http.get(
      URL.API_SCHOOL_SECURITY_ALERT_TYPE_COUNT_STATISTICS_MY_CLASS,
      postData
    )
  },
  // 班级-右侧上边列表-该班级的报警记录列表
  getClassAlarmPage(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_CLASS_ALARM_PAGE, postData)
  },
  // 班级-右侧中-柱状图
  getClassHistogram(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_CLASS_HISTOGRAM, postData)
  },
  // 班级-右侧下-折线图
  getClassLineChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_CLASS_LINE_CHART, postData)
  },
  // 班级-右侧中-该班级的饼状图
  getClassPieChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_CLASS_PIE_CHART, postData)
  },
  // 班级-左侧列表-班级统计信息
  getClassStatisticsList(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_CLASS_STATISTICS_LIST, postData)
  },
  // 获取设备列表
  getDeviceList(postData) {
    return http.get(URL.API_SCHOOL_SECURITY_STATISTICS_DEVICE_LIST, postData)
  },
  // 获取设备统计信息
  getDeviceStatistics(postData) {
    return http.get(URL.API_SCHOOL_SECURITY_GET_DEVICE_STATISTICS, postData)
  },
  // 年级-右侧上边列表-该年级的报警记录列表
  getGradeAlarmPage(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_GRADE_ALARM_PAGE, postData)
  },
  // 年级-右侧中-柱状图
  getGradeHistogram(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GRADE_HISTOGRAM, postData)
  },
  // 年级-右侧下-折线图
  getGradeLineChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_GRADE_LINE_CHART, postData)
  },
  // 年级-右侧中-该年级的饼状图
  getGradePieChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_GRADE_PIE_CHART, postData)
  },
  // 年级-左侧列表-年级统计信息
  getGradeStatisticsList(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GRADE_STATISTICS_LIST, postData)
  },
  // 地区-右侧上边列表-该地区的报警记录列表
  getRegionAlarmPage(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_REGION_ALARM_PAGE, postData)
  },
  // 地区-右侧下-折线图
  getRegionLineChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_REGION_LINE_CHART, postData)
  },
  // 地区-右侧中-该地区的饼状图
  getRegionPieChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_REGION_PIE_CHART, postData)
  },
  // 地区-左侧列表-地区统计信息
  getRegionStatisticsList(postData) {
    return http.post(
      URL.API_SCHOOL_SECURITY_GET_REGION_STATISTICS_LIST,
      postData
    )
  },
  // 学生-右侧上边列表-该学生的报警记录列表
  getStudentAlarmPage(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_STUDENT_ALARM_PAGE, postData)
  },
  // 学生-右侧下-折线图
  getStudentLineChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_STUDENT_LINE_CHART, postData)
  },
  // 学生-右侧中-该学生的饼状图
  getStudentPieChart(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_STUDENT_PIE_CHART, postData)
  },
  // 学生-左侧列表-学生统计信息
  getStudentStatisticsList(postData) {
    return http.post(
      URL.API_SCHOOL_SECURITY_GET_STUDENT_STATISTICS_LIST,
      postData
    )
  },
  // 筛选项 - 告警列表
  getFilterAlertTypeList(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_ALERT_TYPES, postData)
  },
  getAlertEventDetails(postData) {
    return http.get(URL.API_SECURITY_ALERT_DETAILS, postData)
  },
  confirmExecute(postData) {
    return http.post(URL.API_SECURITY_ALERT_CONFIRM_EXRCUTE, postData)
  },
  uploadHandledResult(postData) {
    return http.post(URL.API_SECURITY_ALERT_UPLOAD_RESULT, postData)
  },
  getAlertProcessList(postData) {
    return http.get(URL.API_SECURITY_ALERT_EVENT_LIST, postData)
  },
  getMyClassAlertProcessList(postData) {
    return http.get(URL.API_SECURITY_MY_CLASS_ALERT_EVENT_LIST, postData)
  },
  getAlertProcessDetail(postData) {
    return http.get(URL.API_SECURITY_ALERT_EVENT_DETAIL, postData)
  },
  getRecentAlertCause(postData) {
    return http.get(URL.API_SECURITY_ALERT_CAUSES, postData)
  },
  getBullyDevice(postData) {
    return http.post(URL.API_SCHOOL_SECURITY_GET_BULLY_DEVICE, postData)
  },

  // 创建轨迹记录
  createQueryTrackTask(postData) {
    return http.post(URL.API_SECURITY_TRACK_CREATE_QUERY_TRACK_TASK, postData)
  },
  // 按时间查某人的轨迹记录
  getTrackProcess(postData) {
    return http.get(URL.API_SECURITY_TRACK_GET_TRACK_PROCESS, postData)
  },
  // h5-我的班级-右侧上边列表-该学生的报警记录列表
  getMyClassStudentAlarmPage(postData) {
    return http.post(URL.API_SECURITY_GET_MY_CLASS_STUDENT_ALARM_PAGE, postData)
  },
  // h5-我的班级-右侧下-折线图
  getMyClassStudentLineChart(postData) {
    return http.post(URL.API_SECURITY_GET_MyClassStudentLineChart, postData)
  },
  // h5-我的班级-右侧中-该学生的饼状图
  getMyClassStudentPieChart(postData) {
    return http.post(URL.API_SECURITY_GET_MyClassStudentPieChart, postData)
  },
  // h5-我的班级-左侧列表-学生统计信息
  getMyClassStudentStatisticsList(postData) {
    return http.post(URL.API_SECURITY_GET_MyClassStudentStatisticsList, postData)
  },
  // h5-钉盘授权
  uploadFileToDingPermission(postData) {
    return http.post(URL.API_SECURITY_uploadFileToDingPermission, postData)
  },
  // h5-我的班级-查看-告警处理-已完成列表
  getMyClassCompletedAlertList(postData) {
    return http.get(URL.API_SECURITY_getMyClassCompletedAlertList, postData)
  }

}
